import script from "./Order.vue?vue&type=script&setup=true&lang=js"
export * from "./Order.vue?vue&type=script&setup=true&lang=js"

import "./Order.vue?vue&type=style&index=0&id=b4379092&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4379092"]])

export default __exports__